import { z } from 'zod';
import { jsonSchema } from './utils.js';
export const explorerColumnSchema = z.object({
    name: z.string(),
    dataType: z.string(),
    primaryKey: z.boolean(),
    notNull: z.boolean(),
});
export const explorerTableSchema = z.object({
    name: z.string(),
    columns: z.array(explorerColumnSchema),
});
export const explorerTablesResponseSchema = z.object({
    tables: z.array(explorerTableSchema),
});
export const explorerRowsResponseSchema = z.object({
    columns: z.array(z.string()),
    // Use jsonSchema (not z.unknown / z.lazy) so OpenAPI generation stays safe.
    rows: z.array(z.record(z.string(), jsonSchema)),
    total: z.number(),
    limit: z.number(),
    offset: z.number(),
});
export const explorerUpdateRowInputSchema = z.object({
    primaryKey: z.record(z.string(), jsonSchema),
    patch: z.record(z.string(), jsonSchema),
});
export const explorerUpdateRowResponseSchema = z.object({
    row: z.record(z.string(), jsonSchema),
});
export const explorerSqlInputSchema = z.object({
    statement: z.string().min(1),
    /** Max rows to return (capped server-side). Omit for the default cap. */
    limit: z.number().int().positive().max(10000).optional(),
});
export const explorerSqlResponseSchema = z.object({
    columns: z.array(z.string()),
    rows: z.array(z.record(z.string(), jsonSchema)),
    rowCount: z.number(),
    command: z.string(),
});
